import React, { FC, useCallback } from 'react';
import Droplist from './components/droplist';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import { TDealerFilterComponentProps } from '../../types/dealerLocatorLanding.types';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import './styles.scss';

const DealerLocatorDesktopFilters: FC<TDealerFilterComponentProps> = ({ filters, selectedFilters, updateFilters }) => {
    // Todo: Replace this code with line no. 14 and 15 for Services Ref US-446445 
      /* const { Equipments, Services } = filters;
      const { equipmentSelectedOptions, serviceSelectedOptions } = selectedFilters; */
    // End Code comments US-446445 
  const { Equipments } = filters;
  const { equipmentSelectedOptions } = selectedFilters;
  const getColumnCount = useCallback(
    (filterList: any[] = []): number => {
      const columnCount = Math.round(filterList?.length / 8) || 1;
      return Math.min(columnCount, 3);
    },
    [filters]
  );

  const getTotalFiltersSelected = useCallback(
    (filtersObj = {}): string => {
      const count = Object.values(filtersObj)?.length || 0;
      if (count) {
        return ` (${count})`;
      } else {
        return '';
      }
    },
    [filters]
  );

  const resetAllFilter = useCallback(() => {
    updateFilters({
      equipmentSelectedOptions: {},
      // Todo: Uncomment this code for Services against US-446445
      // serviceSelectedOptions: {},
      // End Code comments US-446445
    });
  }, [filters]);

  const equipmentSelectedFiltersCount = getTotalFiltersSelected(equipmentSelectedOptions);
  // Todo: Uncomment this code for Services against US-446445
  // const seriesSelectedFiltersCount = getTotalFiltersSelected(serviceSelectedOptions);
  // End Code comments US-446445

  return (
    <div className="dealer-locator-dsk-filters">
      <div className="dealer-locator-dsk-filters__droplists">
        <Droplist
          optionColumnCount={getColumnCount(Equipments)}
          droplistTitle={
            <span>
              <DictionaryTerm keyword="cnhi-dealerLocatorEquipment" />
              {equipmentSelectedFiltersCount}
            </span>
          }
          droplistOptions={Equipments}
          filterKeyName="equipmentSelectedOptions"
          selectedFilters={selectedFilters}
          updateFilters={updateFilters}
        />
        {/* Todo: Uncomment this code for Services against US-446445
        <Droplist
          optionColumnCount={getColumnCount(Services)}
          droplistTitle={
            <span>
              <DictionaryTerm keyword="cnhi-dealerLocatorService" />
              {seriesSelectedFiltersCount}
            </span>
          }
          droplistOptions={Services}
          filterKeyName="serviceSelectedOptions"
          selectedFilters={selectedFilters}
          updateFilters={updateFilters}
        />
        End Code comments US-446445 */}
      </div>
      {/* Todo: Replace this code with line no. 85 for Services Ref US-446445 
       (equipmentSelectedFiltersCount || seriesSelectedFiltersCount)
      End Code comments US-446445 */}
      {equipmentSelectedFiltersCount && (
        <div className="dealer-locator-dsk-filters__reset-link" onClick={resetAllFilter}>
          <DictionaryTerm keyword="cnhi-dealerAllResetFilters" />
          <Icon iconName="action-refresh" size={iconSize['dsk']} color="primary" />
        </div>
      )}
    </div>
  );
};

export default DealerLocatorDesktopFilters;
